import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import CatastropheFormField from './CatastropheFormField';

const QuestionPanel = ({
  section,
  formData,
  onFormDataChange,
  onNext,
  onPrevious,
  isFirstSection,
  isLastSection
}) => {
  const handleFieldChange = (fieldId, value) => {
    // Create or update the section data
    const sectionData = {
      ...(formData[section.id] || {}),
      [fieldId]: value
    };

    // Remove any duplicate data at the root level
    const newFormData = { ...formData };
    delete newFormData[fieldId];

    // Update the form data with the new section data
    onFormDataChange({
      ...newFormData,
      [section.id]: sectionData
    });
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-8">
        <h2 className="text-xl font-semibold" style={{ color: 'var(--succession-text-primary)' }}>{section.title}</h2>
        <p className="mt-2 text-sm" style={{ color: 'var(--succession-text-secondary)' }}>{section.description}</p>
        {section.helpText && (
          <p className="mt-2 text-sm" style={{ color: 'var(--succession-info)' }}>{section.helpText}</p>
        )}
      </div>

      <div className="space-y-6">
        {section.fields.map((field) => (
          <CatastropheFormField
            key={field.id}
            field={field}
            value={formData[section.id]?.[field.id]}
            formData={formData}
            onChange={(value) => handleFieldChange(field.id, value)}
          />
        ))}
      </div>

      <div className="mt-8 flex justify-between">
        <button
          onClick={onPrevious}
          disabled={isFirstSection}
          className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm ${
            isFirstSection
              ? 'cursor-not-allowed opacity-50'
              : 'text-white focus:outline-none focus:ring-2 focus:ring-offset-2'
          }`}
          style={isFirstSection ? { backgroundColor: 'var(--succession-bg-tertiary)' } : { backgroundColor: 'var(--succession-primary)', focusRingColor: 'var(--succession-primary)' }}
        >
          <ChevronLeftIcon className="h-5 w-5 mr-2" />
          Previous
        </button>

        <button
          onClick={onNext}
          disabled={isLastSection}
          className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm ${
            isLastSection
              ? 'cursor-not-allowed opacity-50'
              : 'text-white focus:outline-none focus:ring-2 focus:ring-offset-2'
          }`}
          style={isLastSection ? { backgroundColor: 'var(--succession-bg-tertiary)' } : { backgroundColor: 'var(--succession-primary)', focusRingColor: 'var(--succession-primary)' }}
        >
          Next
          <ChevronRightIcon className="h-5 w-5 ml-2" />
        </button>
      </div>
    </div>
  );
};

export default QuestionPanel; 